import React from "react";
import { useEffect } from "react";

export const AutoInitiatePrint = ({ src, id = "" }) => {
  useEffect(() => {
    const iframe = document.getElementById("auto-initiate-print-" + id);
    iframe.onload = () => {
      //if labelsrc actually has a value, print
      //honestly, this only so it doesn't initiate a blank print on page load.
      if (src) {
        const pdfFrame = window.frames["pdf"];
        pdfFrame.focus();
        pdfFrame.print();
        // console.log("window iframe", pdfFrame);
      }
    };
  });
  //   useEffect(() => {

  //   }, [src]);

  return (
    <iframe
      id={"auto-initiate-print-" + id}
      name="pdf"
      src={src}
      hidden
    ></iframe>
  );
};
